module.exports = __webpack_public_path__ + "static/media/DK4050_05.2d0a4d3e.jpg";